import { Button as NButton, type ButtonProps as Props } from '@heroui/react';

export const Button = (props: Props) => {
  return <NButton radius='sm' {...props} />;
};
